import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth: let AuthCallback exchange the session_id first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    check();
  }, [check]);

  const login = useCallback(async (phone, password) => {
    const { data } = await api.post("/auth/login", { phone, password });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const loginWithGoogle = useCallback(async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout request failed", err);
    }
    localStorage.removeItem("token");
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, loading, login, loginWithGoogle, logout }), [user, loading, login, loginWithGoogle, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
